export default __webpack_public_path__ + "static/truck-4324b3b92da5bb258cad8f7ed9ec5977.svg";